export default {
  statScientistsTitle: "Scientifiques et chercheurs",
  statScientistsDescription: "Professionnels dévoués qui stimulent l'innovation dans la recherche et le développement pharmaceutiques",
  statScientistsImage: "https://readdy.ai/api/search-image?query=Scientifiques%20et%20chercheurs%20pharmaceutiques%20professionnels%20travaillant%20dans%20un%20laboratoire%20moderne&width=400&height=300",
  statProductsTitle: "Produits pharmaceutiques",
  statProductsDescription: "Portefeuille complet de produits pharmaceutiques et d'API de haute qualité",
  statProductsImage: "https://readdy.ai/api/search-image?query=Portefeuille%20complet%20de%20produits%20pharmaceutiques%20de%20haute%20qualit%C3%A9&width=400&height=300",
  statMarketsTitle: "Marchés mondiaux",
  statMarketsDescription: "Répondre aux besoins de santé dans divers marchés internationaux avec excellence réglementaire",
  statMarketsImage: "https://readdy.ai/api/search-image?query=March%C3%A9s%20pharmaceutiques%20mondiaux%20et%20distribution%20sanitaire%20internationale&width=400&height=300",
};

